(function () {

    'use strict';

    angular.module('iplusjs.utils.device', [
        'lodash',
        'bowser'
    ])
    .service('DeviceUtilsService', DeviceUtilsService);

    DeviceUtilsService.$inject = [
        '$log',
        '$window',
        'bowser',
        'lodash',
        'HtmlUtilsService'
    ];
    function DeviceUtilsService($log, $window, bowser, _, HtmlUtilsService) {
        var that = this,
            bowserCache = {};

        that.isIEIntranet = isIEIntranet;
        that.getBrowser = getBrowser;
        that.isMSIE = isMSIE;
        that.getBowser = getBowser;
        that.getUserAgent = getUserAgent;
        that.supportsPopups = supportsPopups;
        that.isElectron = isElectron;
        that.isMacOsCna = isMacOsCna;
        that.isWebView = isWebView;
        that.isAndroidWebview = isAndroidWebview;
        that.isStandAlone = isStandAlone;
        that.isInsidePopup = isInsidePopup;
        that.isFacebookWebView = isFacebookWebView;
        that.isFirefoxFocusIOS = isFirefoxFocusIOS;
        that.isEdgeIOS = isEdgeIOS;
        that.isOperaMini = isOperaMini;
        that.isAndroid = isAndroid;
        that.isIos = isIos;
        that.isGoogleSearchApp = isGoogleSearchApp;
        that.isQQBrowser = isQQBrowser;
        that.isIosWebview = isIosWebview;
        that.getIosVersion = getIosVersion;
        function isIEIntranet() {
            if ($window.document.documentMode) {
                try {
                    var status = $window.status;

                    $window.status = 'testIntranetMode';

                    if ($window.status === 'testIntranetMode') {
                        $window.status = status;
                        return true;
                    }

                    return false;

                } catch (err) {
                    return false;
                }
            }

            return false;
        }
        function getBrowser(browsers) {
            var _getBowser = getBowser(),
                browser = {};

            if (!_.size(browsers)) {
                browser = {
                    browser: _.toLower(_getBowser.name),
                    version: _getBowser.version,
                    bowser: _getBowser,
                    supportedBrowsers: null
                };
            } else {
                _.each(browsers, function (value, key) {
                    if (_getBowser[key]) {
                        browser = {
                            browser: key,
                            version: _getBowser.version,
                            bowser: _getBowser,
                            supportedBrowsers: browsers
                        };
                        return false;
                    }
                });
            }

            return browser;
        }

        function isMSIE() {
            return (getBrowser() || {}).browser === 'internet explorer';
        }
        function getBowser() {
            var userAgent = getUserAgent();

            if (bowserCache[userAgent]) {
                return bowserCache[userAgent];
            }

            bowserCache[userAgent] = bowser.detect(userAgent);
            bowserCache[userAgent].compareVersions = bowser.compareVersions;

            return bowserCache[userAgent];
        }
        function getUserAgent() {
            return $window.navigator.mockUserAgent || $window.navigator.userAgent;
        }
        function supportsPopups(ua) {
            ua = ua || getUserAgent();

            return !(
                isIEIntranet() ||
                isIosWebview(ua) ||
                isAndroidWebview(ua) ||
                isOperaMini(ua) ||
                isFirefoxFocusIOS(ua) ||
                isEdgeIOS(ua) ||
                isFacebookWebView(ua) ||
                isQQBrowser(ua) ||
                isElectron() ||
                isMacOsCna() ||
                isStandAlone() ||
                isAlohaIOS(ua)
            );
        }
        function isElectron() {
            if (typeof $window.process !== 'undefined' && $window.process.versions && $window.process.versions.electron) {
                return true;
            }
            return false;
        }
        function isMacOsCna() {
            var userAgent = getUserAgent();
            return (/Macintosh.*AppleWebKit(?!.*Safari)/i).test(userAgent);
        }
        function isWebView() {
            return (
                isFacebookWebView() ||
                isIosWebview() ||
                isAndroidWebview()
            );
        }
        function isAndroidWebview(ua) {
            ua = ua || getUserAgent();

            if (isAndroid(ua)) {
                return (/Version\/[\d.]+/).test(ua) && !isOperaMini(ua);
            }

            return false;
        }
        function isStandAlone() {
            return (
                !isInsidePopup() && (
                    $window.navigator.standalone === true ||
                    $window.matchMedia('(display-mode: standalone)').matches
                )
            );
        }
        function isInsidePopup() {
            return !!HtmlUtilsService.getOpener(HtmlUtilsService.getParent($window));
        }
        function isFacebookWebView(ua) {
            ua = ua || getUserAgent();
            return (
                ua.indexOf('FBAN') !== -1 ||
                ua.indexOf('FBAV') !== -1
            );
        }
        function isFirefoxFocusIOS(ua) {
            ua = ua || getUserAgent();

            var _getBowser = getBowser();
            if (
                _.toLower(_getBowser.name) === 'firefox' &&
                bowser.compareVersions([
                    _getBowser.version,
                    '14'
                ]) !== -1
            ) {
                return false;
            }

            return (/FxiOS/i).test(ua);
        }
        function isEdgeIOS(ua) {
            ua = ua || getUserAgent();
            return (/EdgiOS/i).test(ua);
        }
        function isOperaMini(ua) {
            ua = ua || getUserAgent();
            return ua.indexOf('Opera Mini') > -1;
        }
        function isAndroid(ua) {
            ua = ua || getUserAgent();
            return (/Android/).test(ua);
        }
        function isIos(ua) {
            ua = ua || getUserAgent();
            return (/iPhone|iPod|iPad/).test(ua);
        }
        function isGoogleSearchApp(ua) {
            ua = ua || getUserAgent();
            return (/\bGSA\b/).test(ua);
        }
        function isQQBrowser(ua) {
            ua = ua || getUserAgent();
            return (/QQBrowser/).test(ua);
        }
        function isIosWebview(ua) {
            if (isIos(ua)) {
                if (isGoogleSearchApp(ua)) {
                    return true;
                }
                return (/.+AppleWebKit(?!.*Safari)/).test(ua);
            }
            return false;
        }
        function isAlohaIOS(ua) {
            ua = ua || getUserAgent();
            return isIos(ua) && (/AlohaBrowser/).test(ua);
        }
        function getIosVersion() {
            if (!isIos()) {
                return [0];
            }

            try {
                var version = ($window.navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/) || [];

                return [
                    parseInt(version[1], 10),
                    parseInt(version[2], 10),
                    parseInt(version[3] || 0, 10)
                ];
            } catch (e) {
                return [0];
            }
        }
    }

})();
